import {
    BxfChatPromptBox,
    BxfLink,
    BxfTargetAtrEnum,
} from '@blk/bxf-react-components';
import styled from '@emotion/styled';

import { ChatFooterConstants, DISCLAIMER_MESSAGE } from '../constants';
import { useChatBlkStore, useChatPromptBox } from '../hooks';

const ChatFooterContainer = styled.div<{ hasRecentPromptsStyling: boolean }>`
    padding: 1rem 1.5rem 1.5rem 1.5rem;
    padding-right: ${(props) =>
        props.hasRecentPromptsStyling ? '48px' : '24px'};
`;

const ChatFooterDisclaimer = styled.div`
    margin-top: 0.24rem;
    line-height: 21px;
    font-size: 14px;
`;

const {
    LINK_LABEL_LEARN_MORE,
    LINK_LABEL_PRIVACY_NOTICE,
    LINK_LABEL_TERMS_OF_USE,
    LINK_LABEL_IMPORTANT_INFO,
    CHAT_CANVAS_FOOTER_SLOT,
    CHAT_PROMPT_BOX_DISCLAIMER_SLOT,
    DATA_CY_CHAT_PROMPT_BOX,
    PROMPT_BOX_MAX_CHARS,
    PROMPT_BOX_MAX_HEIGHT,
    TERMS_OF_USE_LINK,
    LEARN_MORE_LINK,
    PRIVACY_NOTICE_LINK,
} = ChatFooterConstants;

const ChatFooter = (): JSX.Element => {
    const {
        promptBoxRef,
        isGeneratingResponse,
        handleResponseSubmitted,
        handleResponseCancelled,
        handleImportantInfoClicked,
    } = useChatPromptBox();
    const { hasRecentPromptsStyling } = useChatBlkStore();

    return (
        <ChatFooterContainer
            slot={CHAT_CANVAS_FOOTER_SLOT}
            hasRecentPromptsStyling={hasRecentPromptsStyling}
        >
            <BxfChatPromptBox
                ref={promptBoxRef}
                isGeneratingResponse={isGeneratingResponse}
                isDisabled={isGeneratingResponse}
                maxCharacters={PROMPT_BOX_MAX_CHARS}
                data-cy={DATA_CY_CHAT_PROMPT_BOX}
                dataLinkEvent={'chatblk | prompt'}
                onActiveResponseCancelled={handleResponseCancelled}
                textAreaMaxHeight={PROMPT_BOX_MAX_HEIGHT}
                onSubmitClicked={handleResponseSubmitted}
            >
                <ChatFooterDisclaimer slot={CHAT_PROMPT_BOX_DISCLAIMER_SLOT}>
                    {DISCLAIMER_MESSAGE}&nbsp;
                    <BxfLink
                        label={LINK_LABEL_LEARN_MORE}
                        href={LEARN_MORE_LINK}
                        target={BxfTargetAtrEnum.BLANK}
                        dataLinkEvent={`chatblk | disclaimer | link click | ${LINK_LABEL_LEARN_MORE.toLowerCase()}`}
                    />
                    &nbsp; and see&nbsp;
                    <BxfLink
                        label={LINK_LABEL_IMPORTANT_INFO}
                        dataLinkEvent={`chatblk | disclaimer | link click | ${LINK_LABEL_IMPORTANT_INFO.toLowerCase()}`}
                        onClick={(e) =>
                            handleImportantInfoClicked(e as unknown as Event)
                        }
                        onKeyDown={(e) =>
                            handleImportantInfoClicked(e as unknown as Event)
                        }
                    />
                    ,&nbsp;
                    <BxfLink
                        label={LINK_LABEL_TERMS_OF_USE}
                        href={TERMS_OF_USE_LINK}
                        target={BxfTargetAtrEnum.BLANK}
                        dataLinkEvent={`chatblk | disclaimer | link click | ${LINK_LABEL_TERMS_OF_USE.toLowerCase()}`}
                    />
                    &nbsp;and&nbsp;
                    <BxfLink
                        label={LINK_LABEL_PRIVACY_NOTICE}
                        href={PRIVACY_NOTICE_LINK}
                        target={BxfTargetAtrEnum.BLANK}
                        dataLinkEvent={`chatblk | disclaimer | link click | ${LINK_LABEL_PRIVACY_NOTICE.toLowerCase()}`}
                    />
                    .
                </ChatFooterDisclaimer>
            </BxfChatPromptBox>
        </ChatFooterContainer>
    );
};

export default ChatFooter;
